module.exports = __webpack_public_path__ + "img/1473710591.5d60cbad.jpg";